"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HelpMenu = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var icons_1 = __importDefault(require("../../../assets/icons"));
var ActionsMenu_1 = require("../ActionsMenu/ActionsMenu");
var HelpMenu_logic_1 = require("./HelpMenu.logic");
/**
 * HelpMenu molecule
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/molecules-helpmenu--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/molecules/HelpMenu Source}
 */
var HelpMenu = function (_a) {
    var documentationUrl = _a.documentationUrl, faqUrl = _a.faqUrl, buttonTooltip = _a.buttonTooltip, className = _a.className;
    var helpItems = (0, HelpMenu_logic_1.useHelpMenu)({ documentationUrl: documentationUrl, faqUrl: faqUrl }).helpItems;
    if (!helpItems.length) {
        return null;
    }
    return (0, jsx_runtime_1.jsx)(ActionsMenu_1.ActionsMenu, { actions: helpItems, tooltip: buttonTooltip, icon: icons_1.default.help, className: className });
};
exports.HelpMenu = HelpMenu;
